export const ClientsMainCarrousel = ({ props }) => {
  return (
    <div className="grupo-logos-empresas">
      <div className="logo-empresa">
        <img src={props.imgSrc} alt={props.imgAlt} />
      </div>
    </div>
  );
};
